import { apiClient } from './api';

export const auditAPI = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.user_id) params.append('user_id', filters.user_id);
    if (filters.action) params.append('action', filters.action);
    if (filters.resource_type) params.append('resource_type', filters.resource_type);
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.limit) params.append('limit', filters.limit);
    
    const queryString = params.toString();
    return apiClient.get(`/audit-logs${queryString ? `?${queryString}` : ''}`);
  }
};